import { render, staticRenderFns } from "./TLSCardViolin2.vue?vue&type=template&id=56cabd24&scoped=true&"
import script from "./TLSCardViolin2.vue?vue&type=script&lang=js&"
export * from "./TLSCardViolin2.vue?vue&type=script&lang=js&"
import style0 from "./TLSCardViolin2.vue?vue&type=style&index=0&id=56cabd24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cabd24",
  null
  
)

export default component.exports